export default "__VITE_ASSET__C3CTG9hS__"